import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Core components
import Backdrop from 'components/core/Backdrop';
import AppLoader from 'components/core/AppLoader';

const ActionLoader = ({ loading: { operation, processing } }) => (
  <Backdrop open={operation} invisible={processing}>
    <AppLoader context="contrasted" />
  </Backdrop>
);

ActionLoader.propTypes = {
  loading: PropTypes.shape({
    operation: PropTypes.bool.isRequired,
    processing: PropTypes.bool.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.loading,
});

module.exports = connect(
  mapStateToProps,
  null,
)(ActionLoader);



// WEBPACK FOOTER //
// ./components/loaders/ActionLoader.js